// extracted by mini-css-extract-plugin
module.exports = {"mcLogoLink":"src-components-layouts-step-module__mcLogoLink--32whz","mcLogo":"src-components-layouts-step-module__mcLogo--15aF5"};